<script>
import { mapActions } from 'vuex'
import { add, edit } from '@/api/marca'
import fields from './fields'
import { setFocus } from '@/services/crud'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  data: () => ({
    fields,
    form: {}
  }),
  methods: {
    ...mapActions({
      toaster: 'modal/toaster'
    }),
    focuInicial () {
      setFocus('input[type="text"]', this.$refs.form.$el)
    },
    refresh (data) {
      this.form = JSON.parse(JSON.stringify(data))
      if (!this.form.id) this.$refs.form.instance.resetValues()
      this.focuInicial()
    },
    async salvar () {
      // Salvar Editar
      try {
        let valida = this.$refs.form.instance.validate()
        if (!valida.isValid) throw new Error('Campos Inválidos')
        let data = {}
        if (this.form.id) {
          data = await edit(this.form.id, this.form)
          this.toaster({ message: 'Editado com sucesso!', color: 'success' })
        } else {
          data = await add(this.form)
          this.toaster({ message: 'Adicionado com sucesso!', color: 'success' })
        }
        this.$emit('save', data)
      } catch (e) {
        this.toaster({ message: e.message, color: 'error' })
      }
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Adicionar" @onClose="() => $emit('cancel')">
    <dx-form ref="form" label-location="top" :form-data="form" :items="fields" :onEditorEnterKey="salvar" />
    <ui-acao-form @save="salvar" @cancel="$emit('cancel')" />
  </ui-layout-modal>
</template>

<style scoped>
  .card-form {
    text-align: left;
  }
</style>
